import type {
  ComponentDragState,
  EditorArea,
  HighlightedSpacingDirection,
  IsolationState,
  ManipulationRootState,
  RightSideTab,
} from './types';

export const selectCurrentViewId = (state: ManipulationRootState): number | null => state.manipulation.viewId;

export const selectSelectedComponentId = (state: ManipulationRootState): string | null =>
  state.manipulation.selectedComponentId;

export const selectInitiallySelectedComponentId = (state: ManipulationRootState): string | null =>
  state.manipulation.initiallySelectedComponentId;

export const selectHoveredComponentId = (state: ManipulationRootState): string | null =>
  state.manipulation.hoveredComponentId;

export const selectComponentDrag = (state: ManipulationRootState): ComponentDragState | null =>
  state.manipulation.componentDrag;

export const selectIsDraggingComponent = (state: ManipulationRootState): boolean =>
  state.manipulation.componentDrag != null;

export const selectDraggedComponentId = (state: ManipulationRootState): string | null => {
  const { componentDrag } = state.manipulation;
  return componentDrag?.type === 'move' ? componentDrag.componentId : null;
};

export const selectIsolationState = (state: ManipulationRootState): IsolationState | null =>
  state.manipulation.isolation;

export const selectIsolatedComponentId = (state: ManipulationRootState): string | null =>
  state.manipulation.isolation?.componentId ?? null;

export const selectIsInIsolationMode = (state: ManipulationRootState): boolean => state.manipulation.isolation != null;

export const selectIsolationMode = (state: ManipulationRootState): 'full' | 'light' | null =>
  state.manipulation.isolation?.mode ?? null;

export const selectComponentIsolationEditedStyleClass = (state: ManipulationRootState): string | null =>
  state.manipulation.isolation?.editedStyleClass ?? null;

export const selectFocusedEditorArea = (state: ManipulationRootState): EditorArea => state.manipulation.focusedArea;

export const selectActiveRightSideTab = (state: ManipulationRootState): RightSideTab =>
  state.manipulation.activeRightSideTab;

export const selectHighlightedSpacingDirection = (state: ManipulationRootState): HighlightedSpacingDirection | null =>
  state.manipulation.highlightedSpacingDirection;

export const selectAdapterDataMappingOpen = (state: ManipulationRootState): boolean =>
  state.manipulation.adapterDataMappingOpen;
